import { staticPageData } from './static-page.data';
import { staticPageMapper } from './static-page.mapper';

export const staticPageService = {
  getStaticPage: async (id: number, customerId: number) => {
    const response = await staticPageData.getStaticPage(id, customerId);
    return staticPageMapper.toStaticPageDetail(response);
  },
  getStaticSections: async (customerId: number) => {
    const response = await staticPageData.getStaticSections(customerId);
    return staticPageMapper.toSectionsLinks(response);
  },
};
